// function to load-more items on click. Add class js-load-more to wrapper and js-load-more-item to each item inside as well as js-load-more-btn to the button.
// Set display:none in the css to the items which will be loaded on click

import { slideDown, removeClass } from "./_classesHelper";

class LoadMore {
  constructor() {
    this.wrapper = [...document.querySelectorAll(".js-load-more")];
    this.classNameHidden = "items-hidden";
    this.classNameBtn = ".js-load-more-btn";
    this.classNameItem = ".js-load-more-item";
    this.duration = 500;
    if (this.wrapper && this.wrapper.length > 0) {
      this.init();
    }
  }

  init() {
    this.wrapper.forEach((element) => {
      const items = [...element.querySelectorAll(this.classNameItem)];
      element.querySelector(this.classNameBtn).addEventListener("click", () => {
        items.forEach((el) => {
          slideDown(el, this.duration);
        });

        setTimeout(() => {
          removeClass(element, this.classNameHidden);
        }, this.duration);
      });
    });
  }
}

export default LoadMore;
